<div class="scroll-for-comments" *ngIf="!visible">
    <div>Scroll for Comments</div>
</div>
<div class="comments-container" [class.visible]="visible">
    <div class="loader" *ngIf="!ready" [class.almost-done]="finishingUp">
        <div>
            <div class="message">{{loadingMessage || 'Loading ...'}}</div>
            <div>
                <app-spinner [inline]="true"></app-spinner>
            </div>

            <div class="subnote" *ngIf="attemptNumber === 0">
                Stuck? Try reloading the page.
            </div>
            <div class="subnote" *ngIf="attemptNumber > 0 && attemptNumber < 2">
                Looks like there may be an issue signing into Spot.im.
                We're trying again...
            </div>
            <div class="subnote" *ngIf="attemptNumber > 2">
                Looks like we can't get logged in :-(<br/> 
                Try refreshing the page. If the issue persists, contact support@tytnetwork.com
            </div>
        </div>
    </div>

    <div class="alert alert-membership" *ngIf="ready && !isMember">
        Want to put your two cents in? We want to hear it! Posting comments is only available for <strong>TYT members</strong> in good standing. 
        <a target="_blank" routerLink="/membership-benefits">Click here to learn more about becoming a TYT member.</a>
    </div>

    <div #anchorContainer *ngIf="!reloading">
        <div #anchor></div>
    </div>
</div>